// extracted by mini-css-extract-plugin
export default {"form-input":"FormInput_form-input__DJ1X2","form-label":"FormInput_form-label__47jL9"};